import {
    ChangeDetectionStrategy, Component, Input, OnInit,
} from '@angular/core';
import { Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

import { LinksService } from '../../services/links/links.service';

import { ContentItemTree } from '@features/cms-render/domain/models/contentItemTree';
import { Link } from '@features/cms-render/domain/models/link';
import { getLastSlugWithoutParams } from '@frontend/common/utils';

@Component({
    selector: 'render-link',
    templateUrl: './render-link.component.html',
    styleUrls: ['./render-link.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RenderLinkComponent implements OnInit {
    @Input() public link!: Link;

    @Input() public styleClass: string | undefined;

    @Input() public element: ContentItemTree;

    @Input() public direction: string;

    public linkType: string;

    public ariaLabel: string;

    public dataTitle: string;

    public configUrl$: Observable<string>;

    constructor(
        private readonly linksService: LinksService,
    ) { }

    public ngOnInit(): void {
        this.linkType = this.link?.type;
        this.dataTitle = this.link?.title;
        this.configUrl$ = this.linksService.getUrlByConfig(this.link, this.element).pipe(
            filter((url) => !!url),
            tap((url) => {
                this.ariaLabel = getLastSlugWithoutParams(url);
            })
        );
    }

    public openLink($event: MouseEvent): void {
        this.linksService.openLink($event, this.link, this.element);
    }
}
